// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"bab9c3cd","758":"8f2d4b9e","971":"f3d80fce"}[chunkId] + ".chunk.css";
};